import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { List, Map, OrderedMap } from 'immutable';
import Accordion from '@Components/Accordion';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import ThesaurusItem from '../ThesaurusItem';

import './ThesaurusGroupsList.scss';

const spinnerId = 'ThesaurusGroupsList-spinnerId';

export function getMaxHeight(count, isOpen) {
  if (!isOpen || count === 0) {
    return;
  }

  return `${count * 2.5 + 2}rem`;
}

export function getItems(props, items) {
  return items.map((item) => {
    const id = item.get('id');
    const identificatorOfBatchItems = item.get('rootIds')?.push(id).join();

    return <ThesaurusGroupsList {...props} key={id} item={item} identificatorOfBatchItems={identificatorOfBatchItems} />;
  });
}

export function countVisibleChild(rootId, visibleItems) {
  return visibleItems.count((item) => item.get('rootIds')?.some((id) => id === rootId));
}

const renderAccordion = (props) => {
  const {
    item,
    filter,
    visibleItems,
    openCloseMap,
    onToggleGroup,
    onToggelRootGroup,
    onClickThesaurusItem,
    thesaurusGroupsForView,
    identificatorOfBatchItems,
    thesaurusGroupsPartiallySelectedMap,
  } = props;
  const isRoot = filter === item;
  const items = thesaurusGroupsForView.get(identificatorOfBatchItems);
  const rootId = isRoot ? item.get('thesaurusRootId') : item.get('id');
  const visivleItemsCount = countVisibleChild(rootId, visibleItems);
  const isOpen = Boolean(openCloseMap[identificatorOfBatchItems]);
  const hasChildren = item.get('hasChildren');

  return (
    <Accordion
      open={isOpen}
      style={{
        maxHeight: getMaxHeight(visivleItemsCount, isOpen),
      }}
      timeout={300}
      animationClass="tree-view-dialog-thesaurus-list-animation"
      beforeContent={
        <ThesaurusItem
          item={item}
          isOpen={isOpen}
          filter={filter}
          isRoot={isRoot}
          isFolder={isRoot || hasChildren}
          onToggleGroup={isRoot ? onToggelRootGroup : onToggleGroup}
          onClickThesaurusItem={onClickThesaurusItem}
          thesaurusGroupsPartiallySelectedMap={thesaurusGroupsPartiallySelectedMap}
        />
      }
      content={<>{items ? getItems(props, items) : <RxSpinnerComponent autoStart spinnerId={spinnerId} spinnerScale={1.5} />}</>}
    />
  );
};

const renderItem = (props) => {
  const {
    item,
    filter,
    openCloseMap,
    onToggleGroup,
    onToggelRootGroup,
    onClickThesaurusItem,
    identificatorOfBatchItems,
    thesaurusGroupsPartiallySelectedMap,
  } = props;
  const isRoot = filter === item;
  const isOpen = Boolean(openCloseMap[identificatorOfBatchItems]);
  const hasChildren = item.get('hasChildren');

  return (
    <ThesaurusItem
      item={item}
      isOpen={isOpen}
      filter={filter}
      isRoot={isRoot}
      isFolder={isRoot || hasChildren}
      onToggleGroup={isRoot ? onToggelRootGroup : onToggleGroup}
      onClickThesaurusItem={onClickThesaurusItem}
      thesaurusGroupsPartiallySelectedMap={thesaurusGroupsPartiallySelectedMap}
    />
  );
};

function ThesaurusGroupsList(props) {
  const { openCloseMap, identificatorOfBatchItems } = props;

  return (
    <VisibilitySensor partialVisibility offset={{ top: -1500, bottom: -1000 }}>
      {({ isVisible }) => {
        if (!isVisible) {
          return <div className="tree-view-dialog-thesaurus-list-placeholder">...</div>;
        }
        const isOpen = Boolean(openCloseMap[identificatorOfBatchItems]);

        return isOpen ? renderAccordion(props) : renderItem(props);
      }}
    </VisibilitySensor>
  );
}

ThesaurusGroupsList.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  filter: PropTypes.instanceOf(Map).isRequired,
  visibleItems: PropTypes.instanceOf(List).isRequired,
  openCloseMap: PropTypes.object.isRequired,
  onToggleGroup: PropTypes.func.isRequired,
  onToggelRootGroup: PropTypes.func.isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
  thesaurusGroupsForView: PropTypes.instanceOf(OrderedMap).isRequired,
  identificatorOfBatchItems: PropTypes.string.isRequired,
  thesaurusGroupsPartiallySelectedMap: PropTypes.instanceOf(Map).isRequired,
};

export default ThesaurusGroupsList;
